<template>
    <div data-v-31344d54>
        <div data-v-31344d54="" class="el-card is-always-shadow">
            <div class="el-card__body" style="padding: 16px; text-align: left;">
                <div data-v-31344d54="" class="G-title"><span data-v-31344d54="">商家入驻</span></div>
                <div data-v-31344d54="">
                    <ol data-v-31344d54="" style="padding-inline-start: 15px;">
                        <li data-v-31344d54=""><strong data-v-31344d54="">收费标准：</strong>
                            <ul data-v-31344d54="">
                                商家入驻，不是免费服务，请联系我们获取报价。
                            </ul>
                        </li>
                        <li data-v-31344d54=""><strong data-v-31344d54="">我们接受以下商户的商家：</strong>
                            <ul data-v-31344d54="">
                                <li data-v-31344d54="">各种具备固定经营场所的商务会所、KTV、夜总会；</li>
                                <li data-v-31344d54="">各种具备固定经营场所桑拿、按摩店；</li>
                                <li data-v-31344d54="">各种具备固定经营场所工作室；</li>
                                <li data-v-31344d54="">各种信誉良好的单一城市工作室。</li>
                            </ul>
                        </li>
                        <li data-v-31344d54=""><strong data-v-31344d54="">我们不接受以下类型的商家：</strong>
                            <ul data-v-31344d54="">
                                <li data-v-31344d54="">不接受任何全国范围经营的商家；</li>
                                <li data-v-31344d54="">不接受任何办卡类以及引导办卡类的商户；</li>
                                <li data-v-31344d54="">不接所谓的全国空降类的合作；</li>
                                <li data-v-31344d54="">不接受任何单一楼凤作为商家入驻，楼凤请自行发帖；</li>
                                <li data-v-31344d54="">不接受任何存在欺诈行为的商户，以及价位和服务不对等的商家；</li>
                            </ul>
                        </li>
                        <li data-v-31344d54=""><strong data-v-31344d54="">商家服务：</strong>
                            <ul data-v-31344d54="">
                                <li data-v-31344d54="">提供服务期限内商家频道的展示；</li>
                                <li data-v-31344d54="">在指定的城市信息流里展示；</li>
                                <li data-v-31344d54="">附送指定城市的发帖条数；</li>
                            </ul>
                        </li>
                        <li data-v-31344d54=""><strong data-v-31344d54="">特别条款：</strong>
                            <ul data-v-31344d54="">
                                <li data-v-31344d54="">我们保留拒绝部分商家入驻的权利；</li>
                                <li data-v-31344d54="">如果商家入驻后出现办卡等欺诈行为，收到用户举报，我们将会立即下架，且费用不退；</li>
                                <li data-v-31344d54="">部分信誉存疑的商家初次入驻，我们可能需要对方提供保证金；</li>
                            </ul>
                        </li>
                        <li data-v-31344d54=""><strong data-v-31344d54="">联系我们：</strong>
                            <ul data-v-31344d54="">
                                <li data-v-31344d54="">邮件：hocwfsg@hotmail.com</li>
                                <li data-v-31344d54="">请在联系的时候，请详细介绍你的商家情况以及业务情况，任何没有详细介绍的商家合作信息，我们都不会回复；
                                    我们没有任何QQ和微信，更不会通过微信和QQ主动联系你，请勿上当受骗，如有疑虑请跟我们的官方邮件核实； 我们将会在邮件里，
                                    筛选部分具备合作条件的商家去联系，如48小时没有回复证明不符合我们的合作标准；
                                </li>
                            </ul>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Merchantjoin',
    data() {
        return {
        }
    },
    mounted() {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/merchantjoin.vue